const common = {
  Loading: "Belading",
  signUp: "Aanmelden",
  login: "Inloggen",
  logout: "Uitloggen",
  email: "E-mail",
  emailFormatErrorTips: "Het e-mail formaat is onjuist",
  emailDifferentTips: "Gelieve dezelfde e-mail in te vullen in beide velden.",
  emailRegisteredTips: "Dit E-mail is al geregistreerd, kies een ander.",
  password: "Wachtwoord",
  passwordFormatErrorTips:
    "Het wachtwoord moet 8-50 tekens lang zijn en ten minste twee van de volgende categorieën bevatten: cijfer, letter of speciaal teken.",
  passwordDifferentTips: "Voer in beide velden hetzelfde wachtwoord in.",
  verificationCode: "Verificatie code",
  verificationCodeErrorTips: "Onjuiste verificatie code",
  confirm: "Bevestig",
  cancel: "Annuleren",
  submit: "Verzenden",
  confirmEmail: "Bevestig E-mail",
  formEmptyErrorTips: "Kan hier niet leeg zijn.",
  country: "Land/Regio",
  birthday: "Verjaardag",
  anonymous: "Anoniem",
  name: "Naam",
  nameFormatErrorTips: "Gebruikersnaam moet binnen 50 karakters zijn en mag geen speciale tekens bevatten",
  okBtn: "OK",
  serverErrorTips: "Sorry, er is iets misgegaan, probeer het later nog eens.",
  updateSuccessTips: "Succesvol gewijzigd",
  authorizationExpiredErrorTips: "Autorisatie is verlopen, gelieve opnieuw in te loggen.",
  requestFrequentlyErrorTips: "Er zijn te veel dezelfde verzoeken gedaan in een korte tijd, probeer het later nog eens.",
  GetCode:'code krijgen'
};

export default common;
